module.exports = __webpack_public_path__ + "img/local_library.c2856101.svg";